import React, { FC, memo } from "react";
import { Button, Caption, CopyText } from "@buderus-apps/components";
import styles from './styles.module.scss'

const {
  teaser,
  'teaser__img-wrapper': imgWrapper,
  'teaser__text-wrapper': textWrapper,
  'teaser__link-wrapper': linkWrapper
} = styles

type Props = {
  title: string,
  text: string,
  imgSrc: string,
  imgAlt: string,
  linkHref: string,
  linkText: string
}
const Teaser: FC<Props> = (props) => {
  const { title, text, imgSrc, imgAlt, linkText, linkHref } = props
  return <div className={teaser}>
    <div className={imgWrapper}>
      <img src={imgSrc} alt={imgAlt}/>
    </div>
    <div className={textWrapper}>
      <CopyText type='bold'>{title}</CopyText>
      <Caption>{text}</Caption>
    </div>
    <div className={linkWrapper}>
      <Button
        btnStyle={"secondary"}
        onClick={() => document.location.href = linkHref}
      >
        {linkText}
      </Button>
    </div>
  </div>
}

export default memo(Teaser)